import { FormattedDateTime, PagedSingleSelectControl, Text, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { contactFilterService } from "../shared/api/contactFilterService";
import { ContactFilterType } from "../shared/types";

const LastFilter = styled(Text)`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

interface Props {
	label: string;
	onSelect: (contactFilterId: number) => void;
	types?: ContactFilterType[];
}

const Small = styled.small`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
`;

const fetcher = (search: string, page: number, types: ContactFilterType[]) =>
	contactFilterService.options(search, page, types).then((response) => response.data);

export const ContactFilterSelectControl: FC<Props> = ({
	label,
	onSelect,
	types = ["onDemand", "system", "personal", "public"],
}) => {
	const { t } = useTranslation();
	return (
		<PagedSingleSelectControl
			value={null}
			label={label}
			onChange={(e) => e.target.value && onSelect(e.target.value.id)}
			name="contactFilterSelect"
			fetchConfig={laravelSelectFetchConfig(contactFilterService.optionsKey(types), (search, page) =>
				fetcher(search, page, types),
			)}
			renderOption={(option) => (
				<>
					{option.type === "onDemand" && (
						<>
							<LastFilter>{t("Filter last used on:")}</LastFilter>
							<FormattedDateTime as={Small} dateTime={option.lastUsed} />
						</>
					)}
					{option.type !== "onDemand" && option.name}
				</>
			)}
			onClear={() => void 0}
		/>
	);
};
